export const ERC20 = {
  abi: [
    "function transfer(address to, uint256 value) returns (bool success)",
    "function balanceOf(address owner) view returns (uint)",
  ],
};
